import React from 'react';
import { SvgIcon, SvgIconProps } from '../../../components/svgIcon';

export const InternalChatIconRound = React.forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
  return (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    <SvgIcon cacheName="social/round/internalChatRound" ref={ref as any} {...props}>
      <g clipPath="url(#clip0_318_22860)" fill="none">
        <path
          d="M18.6213 9.42847H18.1948V13.8769C18.1948 14.5695 17.7698 15.1958 16.9179 15.1958H8.57141V15.4073C8.57141 16.0196 9.30532 16.6377 10.059 16.6377H16.4403L18.8816 17.9999L18.5276 16.6377H18.6213C19.3744 16.6377 19.7143 16.0211 19.7143 15.4073V10.4845C19.7143 9.87211 19.3744 9.42847 18.6213 9.42847Z"
          fill="#405368"
        />
        <path
          d="M15.6484 6H6.81458C6.03734 6 5.14288 6.73751 5.14288 7.4484V13.1671C5.14288 13.8218 5.90073 14.2945 6.62765 14.3675L6.15458 16.2857L9.18596 14.3808H15.6484C16.4257 14.3808 17.1429 13.8775 17.1429 13.1671V8.54037V7.4484C17.1429 6.73751 16.4252 6 15.6484 6ZM8.16227 10.8273C7.7215 10.8273 7.36427 10.4458 7.36427 9.97497C7.36427 9.50416 7.7215 9.12259 8.16227 9.12259C8.60258 9.12259 8.96027 9.50416 8.96027 9.97497C8.96027 10.4458 8.60258 10.8273 8.16227 10.8273ZM11.1429 10.8273C10.7021 10.8273 10.3449 10.4458 10.3449 9.97497C10.3449 9.50416 10.7021 9.12259 11.1429 9.12259C11.5837 9.12259 11.9409 9.50416 11.9409 9.97497C11.9409 10.4458 11.5837 10.8273 11.1429 10.8273ZM14.124 10.8273C13.6832 10.8273 13.3255 10.4458 13.3255 9.97497C13.3255 9.50416 13.6832 9.12259 14.124 9.12259C14.5638 9.12259 14.922 9.50416 14.922 9.97497C14.922 10.4458 14.5638 10.8273 14.124 10.8273Z"
          fill="#405368"
        />
        <circle cx="12" cy="12" r="11.5" stroke="#405368" strokeWidth="1" />
      </g>
    </SvgIcon>
  );
});
